import React, { useContext } from 'react';
import {
  Connect,
  PropsFromRedux,
} from './AddOneDecisionToFolderDropdownContainer';
import { AddToFoldersDropdown } from './AddToFoldersDropdown';
import {
  FoldersToastDecisionAdded,
  FoldersToastFolderAlreadyAdded,
  FoldersToastFolderCreated,
} from '../toast/FoldersToast';
import { FoldersDropdownContext } from './FoldersDropdownContext';
import { folderToast } from '../toast/folderToast';
import { FolderSelectionType } from './foldersDropdown.types';

type Props = {
  isLoading: boolean;
} & PropsFromRedux;

export const RawAddOneDecisionToFolderDropdown: React.FC<Props> = ({
  isLoading,
  createNewFolder,
  saveInFolder,
}) => {
  const { closeDropdown } = useContext(FoldersDropdownContext);
  const onFolderSelectCallback = ({
    folder,
    searchActive,
  }: {
    folder: FolderSelectionType;
    searchActive: boolean;
  }) => {
    closeDropdown();
    if (!folder.selected) {
      const { folderKey } = folder;
      saveInFolder({ searchActive, folderKey });
      folderToast(
        <FoldersToastDecisionAdded
          href={`/dossiers/${folder.folderKey}?source=folder-toaster-create`}
          title={folder.title}
        />,
      );
    } else {
      folderToast(
        <FoldersToastFolderAlreadyAdded
          href={`/dossiers/${folder.folderKey}?source=folder-toaster-already`}
          title={folder.title}
        />,
      );
    }
  };

  const createNewFolderCallback = async ({
    title,
    source,
  }: {
    title: string;
    source: string;
  }) => {
    const folder = await createNewFolder({ title, source });
    closeDropdown();
    if (folder)
      folderToast(
        <FoldersToastFolderCreated
          href={`/dossiers/${folder.folderKey}?source=folder-toaster-new-folder`}
          title={folder.title}
        />,
      );
  };

  return (
    <AddToFoldersDropdown
      isLoading={isLoading}
      onFolderSelect={onFolderSelectCallback}
      onFolderCreate={createNewFolderCallback}
    />
  );
};

export const AddOneDecisionToFolderDropdown = Connect(
  RawAddOneDecisionToFolderDropdown,
);
